import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaCheckDouble,
  FaHandshake,
  FaChartPie,
  FaUserGraduate,
  FaArrowRight,
} from 'react-icons/fa';
import './Services.css';

// Liste des 4 services. La carte titre + la carte CTA encadrent ces 4 services.
const servicesData = [
  {
    icon: <FaCheckDouble />,
    category: 'Meilleure prise de décision',
    title: 'EXPERTISE IMMOBILIÈRE',
    to: '/services/expertise',
  },
  {
    icon: <FaHandshake />,
    category: 'Stratégie gagnante',
    title: 'CONSEIL STRATÉGIQUE',
    to: '/services/conseil',
  },
  {
    icon: <FaChartPie />,
    category: 'Vision claire',
    title: 'ETUDES IMMOBILIÈRES',
    to: '/services/etudes',
  },
  {
    icon: <FaUserGraduate />,
    category: 'Montée en compétence',
    title: 'FORMATION PRO',
    to: '/services/formation',
  },
];

const Services = () => {
  return (
    <section className="services-section">
      <div className="container">
        <div className="services-grid">

          {/* 1. Carte de Titre (Bloc Bleu) */}
          <div className="service-card title-card">
            <div className="title-content">
              <h5>NOS SERVICES</h5>
              <h2>CE QUE ATAA <br />  FAIT POUR VOUS <br /></h2>
            </div>
          </div>

          {/* 2-5. Les 4 services cliquables */}
          {servicesData.map((service, index) => (
            <Link to={service.to} className="service-card service-card-link" key={index}>
              <div className="card-icon">{service.icon}</div>
              <div className="card-content">
                <span className="card-category">{service.category}</span>
                <h3 className="card-title">{service.title}</h3>
                <span className="card-arrow"><FaArrowRight /></span>
              </div>
            </Link>
          ))}

          {/* 6. Carte Appel à l'Action -> /contact */}
          <Link to="/contact" className="service-card special-card">
            <div className="special-content">
              <div className="big-arrow"><FaArrowRight /></div>
              <h3>Je formule une demande</h3>
            </div>
          </Link>

        </div>
      </div>
    </section>
  );
};

export default Services;
